// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyDxPtaF7M-30Flq6l1_77XIqduFVMOddec",
	authDomain: "lane-react.firebaseapp.com",
	projectId: "lane-react",
	storageBucket: "lane-react.firebasestorage.app",
	messagingSenderId: "53710369368",
	appId: "1:53710369368:web:ee31f6f108f05fe491102d",
	measurementId: "G-HCNZCPK54Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
export { database };
